import { action } from "satcheljs";
import { IShiftEntity } from "sh-models";
import { ShiftStoreTypes } from "sh-application/../StaffHubConstants";
import { IPreviewSchedulePageStore } from "../../../sh-application/components/previewSchedulePage";
import { SchedulesViewStateStore } from "../../../sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";

const deleteShifts = action(
    "DELETE_SHIFTS",
    (
        shiftsDeleted: IShiftEntity[],
        shiftStoreType: ShiftStoreTypes,
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
    ) => ({
        shiftsDeleted: shiftsDeleted || [],
        shiftStoreType: shiftStoreType,
        viewState:  viewState
    })
);

export default deleteShifts;
